import { useState } from 'react'
import { CloseIcon } from '../../assets/icons/Svg'
import { useDispatch, useSelector } from 'react-redux';
import Label from '../ui/Label';
import Input from '../ui/Input';
import { CreateNewStaffState } from '../../types/user';
import Loading from '../ui/Loading';
import { BasilEyeClosedOutline, IconamoonEyeLight } from '../../assets/icons/Icons';
import { selectCreateNewStaff, selectTypeOfOpen, selectUpdatePassword, setTypeOfOpen, setUpdatePassword, updateCreateNewStaffField } from '../../features/user/userSlice';
import { useQueryData } from '../../hooks/api/useQueryData';
import { useMutationData } from '../../hooks/api/useMutationData';
import useUserAction from '../../hooks/actions/useUserAction';

export default function UpdateProfileDetails() {
    
    const dispatch = useDispatch();
    const createNewStaffState = useSelector(selectCreateNewStaff);
    const typeOfOpenAction = useSelector(selectTypeOfOpen);
    const updatePassword = useSelector(selectUpdatePassword)
    const isActionTypeName = typeOfOpenAction === 'name';
    const isActionTypePassword = typeOfOpenAction === 'password';
    const isUpdateNameOrPass = typeOfOpenAction === 'name' || typeOfOpenAction === 'password';

    const { isErrorUserInfo, isLoadingUserInfo, refetchUserInfo } = useQueryData()
    const { isLoadingUpdateMyAccount } = useMutationData()
    const { handleUpdateProfileDetails, handleCloseViewAndUpdateUserDetails, handleCancelUpdateProfile} = useUserAction()

    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);

    const isButtonDisabled = () => {
        if (isActionTypeName) {
            return !createNewStaffState?.firstName || !createNewStaffState?.lastName;
        }
        if (isActionTypePassword) {
            return !updatePassword.oldPass || !updatePassword.newPass;
        }
        return true; 
    };

    const handleChangeNewStaff = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        dispatch(updateCreateNewStaffField({ field: name as keyof CreateNewStaffState, value }));
    }

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[60%] lg:max-w-[40%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                    Update profile
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={handleCloseViewAndUpdateUserDetails}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='pt-2 space-y-3'>
                            { isLoadingUserInfo ? (
                                <Loading message='Loading...'/>
                            ) : isErrorUserInfo ? (
                                <div className='py-10 px-2 flex text-center items-center justify-center h-full'>Failed to fetch data. Please try again.</div>
                            ) : (
                                <>
                                    <div className='grid grid-cols-2 gap-3'>
                                        <div className={`${isActionTypeName && 'hidden'}`}>
                                            <Label label={'First Name *'}/>
                                            <Input
                                                type={'text'}
                                                name='firstName'
                                                value={createNewStaffState?.firstName ?? ''}
                                                placeholder={'Juan'}
                                                required
                                                disabled
                                            />
                                        </div>
                                        <div className={`${isActionTypeName && 'hidden'}`}>
                                            <Label label={'Middle Name *'}/>
                                            <Input
                                                type={'text'}
                                                name='middleInitial'
                                                value={createNewStaffState?.middleInitial ?? ''}
                                                placeholder={'D'}
                                                maxLength={1}
                                                required
                                                disabled
                                            />
                                        </div>
                                        <div className={`${isActionTypeName && 'hidden'}`}>
                                            <Label label={'Last Name *'}/>
                                            <Input
                                                name='lastName'
                                                type={'text'}
                                                value={createNewStaffState?.lastName ?? ''}
                                                placeholder={'Juan'}
                                                required
                                                disabled
                                            />
                                        </div>
                                        <div className=''>
                                            <Label label={'Email *'}/>
                                            <Input
                                                name='email'
                                                type={'text'}
                                                value={createNewStaffState?.email ?? ''}
                                                disabled
                                                placeholder={'Juan'}
                                                required
                                            />
                                        </div>
                                        <div className=''>
                                            <Label label={'Role *'}/>
                                            <Input
                                                type={'text'}
                                                value={createNewStaffState?.role?.role ?? ''}
                                                disabled
                                                placeholder={'Role'}
                                                required
                                            />
                                        </div>
                                        <div className=''>
                                            <Label label={'Status *'}/>
                                            <Input
                                                type={'text'}
                                                value={createNewStaffState?.status?.status ?? ''}
                                                disabled
                                                placeholder={'Status'}
                                                required
                                            />
                                        </div>
                                        <div className={`${isActionTypePassword && 'hidden'}`}>
                                            <Label label={'Password *'}/>
                                            <Input
                                                type={'Password *'}
                                                value={'*******'}
                                                disabled
                                                placeholder={'******'}
                                                required
                                            />
                                        </div>
                                    </div>

                                    {isUpdateNameOrPass ? (
                                        <>
                                            <hr className="h-px bg-gray-200 border-0" />
                                            <Label label={`Update ${isActionTypePassword ? 'password' : 'name'}`}/>
                                        </>
                                    ) : (
                                        <div className={` grid grid-cols-2 gap-2`}>
                                            <button
                                                onClick={() => {
                                                    refetchUserInfo()
                                                    dispatch(setTypeOfOpen('name'))
                                                }} 
                                                className="text-sm px-4 py-2 rounded font-medium transition-all bg-cbColor text-white"
                                            >
                                                Update Name
                                            </button>
                                            <button 
                                                onClick={() => {
                                                    dispatch(setTypeOfOpen('password'))
                                                }}
                                                className="text-sm px-4 py-2 rounded font-medium transition-all bg-cbColor text-white"
                                            >
                                                Update Password
                                            </button>
                                        </div>
                                    )}

                                    {/* FULLNAME */}
                                    <div className={` grid grid-cols-2 gap-3`}>
                                        {typeOfOpenAction === 'name' && (
                                            <>
                                                <div className=''>
                                                    <Label label={'First Name *'}/>
                                                    <Input
                                                        name='firstName'
                                                        type={'text'}
                                                        value={createNewStaffState?.firstName ?? ''}
                                                        onChange={handleChangeNewStaff}
                                                        placeholder={'Juan'}
                                                        required
                                                    />
                                                </div>
                                                <div className=''>
                                                    <Label label={'Middle Name *'}/>
                                                    <Input
                                                        name='middleInitial'
                                                        type={'text'}
                                                        value={createNewStaffState?.middleInitial ?? ''}
                                                        onChange={handleChangeNewStaff}
                                                        placeholder={'D'}
                                                        maxLength={1}
                                                        required
                                                    />
                                                </div>
                                                <div className=''>
                                                    <Label label={'Last Name *'}/>
                                                    <Input
                                                        name='lastName'
                                                        type={'text'}
                                                        value={createNewStaffState?.lastName ?? ''}
                                                        onChange={handleChangeNewStaff}
                                                        placeholder={'Cruz'}
                                                        required
                                                    />
                                                </div>
                                            </>
                                        )}

                                        {typeOfOpenAction === 'password' && (
                                            <>
                                                <div className=''>
                                                    <Label label={'Old Password *'}/>
                                                    <div className='relative'>
                                                        <input 
                                                            type={showOldPassword ? "text" : "password"}
                                                            autoComplete="current-password"
                                                            value={updatePassword.oldPass}
                                                            onChange={(e) =>
                                                                dispatch(setUpdatePassword({ type: 'old', value: e.target.value }))
                                                            }
                                                            className={`block w-full text-sm rounded border border-gray-300 px-3 py-2 pr-10 shadow-sm outline-none placeholder:text-gray-400 focus:border-black`}
                                                            placeholder={'******'}
                                                            required
                                                            maxLength={6}
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() => setShowOldPassword(!showOldPassword)}
                                                            className="absolute inset-y-0 right-2 flex items-center justify-center text-gray-500"
                                                        >
                                                            {updatePassword.oldPass.length !== 0 && (
                                                                showOldPassword ? (
                                                                    <IconamoonEyeLight width={18} height={18} />
                                                                ) : (
                                                                    <BasilEyeClosedOutline width={18} height={18} />
                                                                )
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className=''>
                                                    <Label label={'New Password *'}/>
                                                    <div className='relative'>
                                                        <input 
                                                            type={showNewPassword ? "text" : "password"}
                                                            autoComplete="current-password"
                                                            value={updatePassword.newPass}
                                                            onChange={(e) =>
                                                                dispatch(setUpdatePassword({ type: 'new', value: e.target.value }))
                                                            }
                                                            className={`block w-full text-sm rounded border border-gray-300 px-3 py-2 pr-10 shadow-sm outline-none placeholder:text-gray-400 focus:border-black`}
                                                            placeholder={'******'}
                                                            required
                                                            maxLength={6}
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                                            className="absolute inset-y-0 right-2 flex items-center justify-center text-gray-500"
                                                        >
                                                            {updatePassword.newPass.length !== 0 && (
                                                                showNewPassword ? (
                                                                    <IconamoonEyeLight width={18} height={18} />
                                                                ) : (
                                                                    <BasilEyeClosedOutline width={18} height={18} />
                                                                )
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {(isUpdateNameOrPass) && (
                                        isLoadingUpdateMyAccount ? (
                                            <button
                                                className="bg-gray-200 text-black cursor-not-allowed inline-flex w-full items-center justify-center rounded p-3 text-sm"
                                            >
                                                <Loading setH="h-[20px]" message="Saving..." />
                                            </button>
                                        ) : (
                                            <div className="grid grid-cols-2 gap-2">
                                                <button
                                                    onClick={handleUpdateProfileDetails}
                                                    disabled={isButtonDisabled()}
                                                    className={`text-sm px-4 py-2 rounded font-medium transition-all   disabled:cursor-not-allowed ${isButtonDisabled() ? 'bg-gray-200 border text-black': 'text-white bg-cbColor'}`}
                                                >
                                                    Save update
                                                </button>
                                                <button
                                                    className="w-full text-sm px-4 py-2 rounded font-medium transition-all bg-gray-200 border text-black"
                                                    onClick={handleCancelUpdateProfile}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        )
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}